import { useMemo } from "react";
import DoneIcon from "../../assets/images/DoneIcon";
import DashedIcon from "../../assets/images/DashedIcon";
import StepperIcon from "../../assets/images/StepperIcon";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const OnboardSideMenu = ({ selectedMenu,jsonobj }: any) => {
  const isEkycRequired = useSelector(
    (state: RootState) => state?.userOnboardingJsonDetails?.isEkycRequired
  );

const sideMenu: string[] = useMemo(() => {
  const menu = jsonobj?.map((item: { name: string }) => item?.name) || [];
  if (isEkycRequired) {
    menu.push("Staff Verification");
  }
  return menu;
}, [jsonobj, isEkycRequired]);
  
  return (
    <div>
      <div className="flex items-center px-[8%] mt-2 md:mt-16 pt-4 md:pt-0">
        { sideMenu?.map((ele: string, index: number) => {
          return (
            <div className={`flex items-center  `}>
              <div className="w-4 flex justify-center">
                {selectedMenu > index ? (
                  <DoneIcon />
                ) : (
                  <>
                    {selectedMenu === index ? (
                      <div>
                        <StepperIcon />
                      </div>
                    ) : (
                      <div className="bg-sideMenuHelpBox h-[6px] w-[6px] rounded-full "></div>
                    )}
                  </>
                )}
              </div>
              <div>{index !== sideMenu?.length - 1 && <DashedIcon />}</div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-around px-[2%] pb-3 md:pb-0">
        {sideMenu?.map((ele: string, index: number) => {
          return <div className="max-w-[74px] ml-4 text-center smallText mt-3 ">{ele}</div>;
        })}
      </div>
    </div>
  );
};
export default OnboardSideMenu;
